import React from "react"
import shuffle from "lodash/shuffle"
import { graphql, useStaticQuery } from "gatsby"
import { ProductList } from "../components"

export const ProductPreviewBlock = ({ maxAmount }) => {
  const { allGorillaProduct } = useStaticQuery(ProductPreviewBlockStaticQuery)
  const { nodes: products } = allGorillaProduct
  const shuffledProducts = shuffle(products).slice(0, maxAmount)
  return <ProductList products={shuffledProducts} />
}

export type ProductPreviewBlockProps = {
  maxAmount: number
}

const ProductPreviewBlockStaticQuery = graphql`
  query {
    allGorillaProduct {
      nodes {
        title
        description
        productType
        id
        url
        price {
          inNear
        }
        productType
        localFile {
          childImageSharp {
            gatsbyImageData(placeholder: NONE, width: 320)
          }
        }
      }
    }
  }
`

export const ProductPreviewBlockFragment = graphql`
  fragment ProductPreviewFields on SanityProductPreview {
    maxAmount
  }
`
